import React, { Component } from 'react';

class InterstitialLeftColumn extends Component {
  
  render() {
    return (
      <div className="col1">

        {
          this.props.accountLogoUrl &&
            <img className="account-logo" src={this.props.accountLogoUrl} />
        }

        <div className="large-heading">
          You've Been Invited To View This Site
        </div>

      </div>
    );
  }
}

export default InterstitialLeftColumn;
